(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golden-category-tiles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('golden-category-tiles')) {
  class GoldenCategoryTiles extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.cards=Array.from(this.querySelectorAll('[data-category-tile]')).map(element=>{
        const catalog=JSON.parse(element.querySelector('[data-category-catalog]').textContent);
        return {element,catalog,frames:Array.from(element.querySelectorAll('[data-category-frame]')),active:0,current:catalog[0]?.id,visible:false,ready:false,failed:false,generation:0,cursor:0,deck:[]};
      });
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered=false;this.focused=false;
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.schedule();}},{signal});
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});
      this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();}),{signal});
      document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
      this.motion.addEventListener('change',()=>{if(!this.motion.matches)this.cards.filter(c=>c.visible).forEach(c=>this.prepare(c));this.schedule();},{signal});
      this.observer=new IntersectionObserver(entries=>{
        for(const entry of entries){const card=this.cards.find(c=>c.element===entry.target);card.visible=entry.isIntersecting;if(card.visible&&!this.motion.matches)this.prepare(card);}
        this.schedule();
      },{threshold:.2});
      this.cards.forEach(card=>{this.shuffle(card);this.observer.observe(card.element);});
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.cards?.forEach(c=>c.generation++);}
    shuffle(card){
      card.deck=card.catalog.slice();
      for(let i=card.deck.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[card.deck[i],card.deck[j]]=[card.deck[j],card.deck[i]];}
      if(card.deck.length>1&&card.deck[0].id===card.current)[card.deck[0],card.deck[1]]=[card.deck[1],card.deck[0]];
      card.cursor=0;
    }
    prepare(card){
      if(card.catalog.length<2||!card.visible||card.pending||card.ready)return;
      if(card.cursor>=card.deck.length)this.shuffle(card);
      const item=card.deck[card.cursor];const image=card.frames[1-card.active].querySelector('img');
      card.ready=false;card.failed=false;card.pending=true;card.next=item;
      const generation=++card.generation;
      image.loading='eager';image.setAttribute('fetchpriority','low');image.width=item.width;image.height=item.height;image.srcset=item.srcset;image.src=item.src;
      image.decode().then(()=>{if(this.isConnected&&card.generation===generation){card.pending=false;card.ready=!!image.naturalWidth;}},()=>{if(this.isConnected&&card.generation===generation){card.pending=false;card.failed=true;}});
    }
    schedule(){
      clearTimeout(this.timer);
      if(!this.isConnected||document.hidden||this.motion.matches||this.hovered||this.focused||!this.cards.some(c=>c.visible&&c.catalog.length>1))return;
      this.timer=setTimeout(()=>this.advance(),1000);
    }
    advance(){
      for(const card of this.cards.filter(c=>c.visible&&c.catalog.length>1)){
        if(card.failed){card.failed=false;card.cursor++;this.prepare(card);continue;}
        if(!card.ready){this.prepare(card);continue;}
        const next=1-card.active;
        card.frames[card.active].hidden=true;card.frames[card.active].removeAttribute('data-active');
        card.frames[next].hidden=false;card.frames[next].setAttribute('data-active','');
        card.active=next;card.current=card.next.id;card.cursor++;card.ready=false;
        this.prepare(card);
      }
      this.schedule();
    }
  }
  customElements.define('golden-category-tiles',GoldenCategoryTiles);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["golden-mood-entry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('golden-mood-entry')) {
    customElements.define('golden-mood-entry',class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready=true;
        const dialog=this.querySelector('dialog');
        const opener=this.querySelector('[data-mood-open]');
        const preview=this.querySelector('[data-mood-preview]');
        const choices=[...this.querySelectorAll('[data-mood-choice]')];
        const showPhoto=choice=>{
          if (!choice || this.selected===choice.dataset.moodChoice) return;
          this.selected=choice.dataset.moodChoice;
          choices.forEach(link=>link.toggleAttribute('data-selected',link===choice));
          const photo=this.querySelector('[data-mood-photo="'+this.selected+'"]');
          const replace=()=>preview.replaceChildren(photo.content.cloneNode(true));
          if (photo) {
            if (document.startViewTransition && !matchMedia('(prefers-reduced-motion:reduce)').matches) document.startViewTransition(replace);
            else replace();
          }
        };
        opener.addEventListener('click',()=>{
          dialog.showModal();
          opener.setAttribute('aria-expanded','true');
          this.previousOverflow=document.documentElement.style.overflow;
          document.documentElement.style.overflow='hidden';
          if (matchMedia('(min-width:750px)').matches) showPhoto(choices[0]);
          else if (!this.thumbsReady) {
            this.querySelectorAll('[data-mood-thumb]').forEach(thumb=>{
              const photo=this.querySelector('[data-mood-photo="'+thumb.dataset.moodThumb+'"]');
              if (photo) thumb.replaceChildren(photo.content.cloneNode(true));
            });
            this.thumbsReady=true;
          }
        });
        this.querySelector('[data-mood-close]').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
        dialog.addEventListener('close',()=>{
          document.documentElement.style.overflow=this.previousOverflow||'';
          opener.setAttribute('aria-expanded','false');
          opener.focus();
        });
        choices.forEach(choice=>{
          choice.addEventListener('pointerenter',()=>{if(matchMedia('(min-width:750px)').matches)showPhoto(choice);});
          choice.addEventListener('focus',()=>{if(matchMedia('(min-width:750px)').matches)showPhoto(choice);});
          choice.addEventListener('click',()=>dialog.close());
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["golden-rotating-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('golden-rotating-showcase')) {
    class GoldenRotatingShowcase extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = Array.from(this.querySelectorAll('[data-showcase-slide]'));

        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.userPaused = false;
        this.busy = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        if (this.slides.length < 2) return;

        this.key = 'golden-showcase-last';
        this.order = this.slides.map((_, i) => i);
        this.shuffle();
        const first = this.order[0];
        this.position = 0;
        this.change(first);

        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
        }, {signal});
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
        this.addEventListener('focusout', () => {
          queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
        }, {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          this.hovered = false;
          this.focused = false;
          this.advance();
        }, {signal});
        this.motion.addEventListener('change', () => { this.userPaused = this.motion.matches;  this.schedule(); }, {signal});
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, {threshold: .15});
        this.observer.observe(this);
        
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
      }
      shuffle() {
        for (let i = this.order.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.order[i], this.order[j]] = [this.order[j], this.order[i]];
        }
        let last;
        try { last = sessionStorage.getItem(this.key); } catch {}
        if (this.slides[this.order[0]].dataset.productId === last) {
          [this.order[0], this.order[1]] = [this.order[1], this.order[0]];
        }
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.visible || document.hidden || this.hovered || this.focused || this.userPaused || this.busy) return;
        this.timer = setTimeout(() => this.advance(), Number(this.dataset.interval));
        this.preload(this.order[(this.position + 1) % this.order.length]);
      }
      preload(index) {
        const img = this.slides[index]?.querySelector('img');
        if (img) img.loading = 'eager';
      }
      async change(index) {
        this.busy = true;
        this.preload(index);
        const slide = this.slides[index];
        const img = slide.querySelector('img');
        try { await img?.decode(); } catch {}
        if (!this.isConnected) return;
        if (!img?.naturalWidth) { this.busy = false; this.schedule(); return; }
        if (this.hovered || this.focused) {
          this.busy = false;
          this.schedule();
          return;
        }
        this.slides.forEach((item, i) => { item.hidden = i !== index; });
        this.index = index;
        try { sessionStorage.setItem(this.key, slide.dataset.productId); } catch {}
        this.busy = false;
        this.schedule();
      }
      advance() {
        if (this.busy) return;
        this.position = (this.position + 1) % this.order.length;
        this.change(this.order[this.position]);
      }
    }
    customElements.define('golden-rotating-showcase', GoldenRotatingShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
